import { WorkAreaMapDocument, WorkAreaMapQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkAreaMapNode = NonNullable<WorkAreaMapQuery['spaceControl']['workAreaMap']>
export type WorkAreaMapLocationNode = NonNullable<
  WorkAreaMapNode['workAreaMapSpaceLocation']
>[number]
export type WorkSpaceNode = NonNullable<WorkAreaMapLocationNode['workSpace']>

interface UseWorkAreaMapProps {
  id: number | null
  date: string
  endTime?: string
  startTime?: string
}

export const useWorkAreaMap = ({ id, date, endTime, startTime }: UseWorkAreaMapProps) => {
  const variables = {
    id: id || 0,
    date,
    endTime,
    startTime,
  }

  const { data, loading, error, refetch } = useQuery(WorkAreaMapDocument, {
    variables,
    skip: !id,
  })

  const workAreaMap: WorkAreaMapNode | null = data?.spaceControl?.workAreaMap || null
  const workAreaMapLocations: WorkAreaMapLocationNode[] =
    workAreaMap?.workAreaMapSpaceLocation.filter((location) => location.workSpace) || []

  return {
    workAreaMap,
    workAreaMapLocations,
    loading,
    error,
    refetch,
  }
}
